import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useRef, useState } from 'react';
import ClockIcon from '../../assets/icons/clock.svg';
const getSecondsLeft = (deadline) => Math.max(Math.ceil((deadline - Date.now()) / 1000), 0);
const CountdownTimer = ({ deadline, running, onTimeExpired, onRemain, remainThreshold = 600, }) => {
    const [secondsLeft, setSecondsLeft] = useState(() => getSecondsLeft(deadline));
    const prevSecondsLeftRef = useRef(secondsLeft);
    useEffect(() => {
        if (!running) {
            return;
        }
        const syncSecondsLeft = () => setSecondsLeft(getSecondsLeft(deadline));
        syncSecondsLeft();
        // Browsers throttle or suspend intervals while the screen is off, so the
        // remaining time is derived from the deadline on every sync instead of
        // being counted down tick by tick.
        const interval = window.setInterval(syncSecondsLeft, 1000);
        document.addEventListener('visibilitychange', syncSecondsLeft);
        window.addEventListener('pageshow', syncSecondsLeft);
        window.addEventListener('focus', syncSecondsLeft);
        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', syncSecondsLeft);
            window.removeEventListener('pageshow', syncSecondsLeft);
            window.removeEventListener('focus', syncSecondsLeft);
        };
    }, [running, deadline]);
    useEffect(() => {
        const prevSecondsLeft = prevSecondsLeftRef.current;
        prevSecondsLeftRef.current = secondsLeft;
        // The remaining time can drop by more than one second at once after the
        // screen was off, so the threshold is detected as a crossing.
        if (onRemain &&
            secondsLeft > 0 &&
            secondsLeft <= remainThreshold &&
            prevSecondsLeft > remainThreshold) {
            onRemain(secondsLeft);
        }
        if (secondsLeft === 0 && running) {
            onTimeExpired();
        }
    }, [secondsLeft]);
    const formatTime = (totalSeconds) => {
        const hours = Math.floor(totalSeconds / 3600)
            .toString()
            .padStart(2, '0');
        const minutes = Math.floor((totalSeconds % 3600) / 60)
            .toString()
            .padStart(2, '0');
        const seconds = (totalSeconds % 60).toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };
    return (_jsxs("div", { className: "countdown", children: [_jsx("div", { className: "countdown-icon", style: { color: '#f39200' }, children: _jsx(ClockIcon, {}) }), _jsx("div", { className: "countdown-timer", children: formatTime(secondsLeft) })] }));
};
export default CountdownTimer;
